var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get } from '../iconRegistry';

/**
 * Icon simply displays an icon stored in the iconRegistry with various styling options
 * It listens to the global plupload instance to know if its 'asset' prop is currently uploading and reflects that state accordingly.
 */
var Icon = (_temp = _class = function (_Component) {
	_inherits(Icon, _Component);

	function Icon() {
		_classCallCheck(this, Icon);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Icon.prototype.render = function render() {
		var _props = this.props,
		    name = _props.name,
		    size = _props.size,
		    style = _props.style,
		    rest = _objectWithoutProperties(_props, ['name', 'size', 'style']);

		var styles = _extends({
			fill: 'currentcolor',
			verticalAlign: 'middle',
			width: parseInt(size),
			height: parseInt(size)
		}, style);

		return React.createElement(
			'svg',
			_extends({ viewBox: '0 0 24 24', preserveAspectRatio: 'xMidYMid meet', style: styles }, rest),
			get(name)
		);
	};

	return Icon;
}(Component), _class.propTypes = {
	/** Name of icon to retrieve from iconRegistry */
	name: PropTypes.string.isRequired,
	/** Size of icon in px, default 24 */
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/** Style object to apply to svg */
	style: PropTypes.object,
	/** className to apply to svg */
	className: PropTypes.string
}, _class.defaultProps = {
	name: '',
	size: 24,
	style: {},
	className: ''
}, _temp);
export { Icon as default };